export class Constants {
  public static readonly TEAMREQUESTSTATE_REQUESTED = 1;
  public static readonly TEAMREQUESTSTATE_APPROVED = 2;
}
